import Header from '../utils/Header'
import Footer from '../utils/Footer';
import Maps from './Maps';
import ContactUs from './ContactUs';
export default function CompleteContact() {

    return (
      <>
        <Header />
        <Maps/>
        <ContactUs/>
        <Footer />
      </>
    );
  }
  